angular.module('console')
.controller('ReportsConsoleController', ['$scope', '$state', '$stateParams', '$location', 'Report', 'RejectedEmailAddresses', 'EmailBlacklist', 'Logger', 'Notification', '$window', 'API_ENDPOINT',
    function($scope, $state, $stateParams, $location, Report, RejectedEmailAddresses, EmailBlacklist, Logger, Notification, $window, API_ENDPOINT) {
        // Sync selected tab with URL param `tab` (0-based index)
        var initialTab = parseInt($stateParams.tab, 10);
        $scope.reportsTabIndex = isNaN(initialTab) ? 0 : initialTab;

        // Update URL without reloading state when tab changes
        $scope.$watch('reportsTabIndex', function(newIndex, oldIndex){
            if (typeof newIndex === 'number' && newIndex !== oldIndex) {
                $state.go('console.reports', { tab: newIndex }, { notify: false, location: 'replace' });
            }
        });
        // related to new invitations, practices and users
        rawEventLogs = [];
        $scope.invitationsRadio = $scope.practicesRadio = $scope.usersRadio = 'day';

        // related to list of reminders
        $scope.pager = {currentPage: 1};
        $scope.itemsPerPage = 10;
        $scope.totalItems = 0;

        // pending review practices
        $scope.pendingPractices = [];

        // rejected email addresses
        $scope.rejections = [];
        $scope.rejectionsPerPage = 20;
        $scope.rejectionsPager = { currentPage: 1 };
        $scope.rejectionsTotal = 0;
        $scope.rejectionsSort = { sort: 'created_at', direction: 'desc' };

        function loadRejections() {
            var offset = ($scope.rejectionsPager.currentPage - 1) * $scope.rejectionsPerPage;
            RejectedEmailAddresses.get({
                limit: $scope.rejectionsPerPage,
                offset: offset,
                sort: $scope.rejectionsSort.sort,
                direction: $scope.rejectionsSort.direction
            }, function(success) {
                $scope.rejections = success.rejections || [];
                $scope.rejectionsTotal = success.total_count || 0;
            }, function(error) {
                // Silently handle authentication errors as authInterceptor will handle the redirect
                if (error.status !== 401 && error.status !== 403) {
                    Logger.log('Failed to load rejected email addresses', error);
                }
            });
        }

        $scope.onRejectionsPageUpdate = function() {
            loadRejections();
        };

        $scope.sortRejectionsBy = function(column) {
            if ($scope.rejectionsSort.sort === column) {
                $scope.rejectionsSort.direction = ($scope.rejectionsSort.direction === 'asc') ? 'desc' : 'asc';
            } else {
                $scope.rejectionsSort.sort = column;
                $scope.rejectionsSort.direction = 'asc';
            }
            $scope.rejectionsPager.currentPage = 1;
            loadRejections();
        };

        $scope.formatRejectionCode = function(rejection) {
            var codes = [];
            
            // Start with result_code
            if (rejection.result_code) {
                codes.push(rejection.result_code);
            }
            
            // Add flags split by comma
            if (rejection.flags) {
                var flags = rejection.flags.split(',').map(function(flag) {
                    return flag.trim();
                }).filter(function(flag) {
                    return flag.length > 0;
                });
                codes = codes.concat(flags);
            }
            
            return codes.join('<br>');
        };

        $scope.formatRejectionAction = function(rejection) {
            var parts = [];
            if (rejection.controller) {
                parts.push(rejection.controller);
            }
            if (rejection.method) {
                parts.push(rejection.method);
            }
            return parts.join('\n');
        };


        $scope.onPageUpdate = function(){
            $scope.eventLogs = rawEventLogs
                .slice((($scope.pager.currentPage - 1) * $scope.itemsPerPage), ($scope.pager.currentPage * $scope.itemsPerPage));
        };

        $scope.toggleInvitations = function(timeType){
            Report.getInvitations({time_type: timeType }, function(success){
                $scope.invitations = success;
            }, function(error) {
                // Silently handle authentication errors as authInterceptor will handle the redirect
                if (error.status !== 401 && error.status !== 403) {
                    Logger.log('Failed to load invitations report', error);
                }
            });
        };

        $scope.togglePractices = function(timeType){
            Report.getPractices({time_type: timeType }, function(success){
                $scope.practices = success;
            }, function(error) {
                // Silently handle authentication errors as authInterceptor will handle the redirect
                if (error.status !== 401 && error.status !== 403) {
                    Logger.log('Failed to load practices report', error);
                }
            });
        };

        $scope.toggleUsers = function(timeType){
            Report.getUsers({time_type: timeType }, function(success){
                $scope.users = success;
            }, function(error) {
                // Silently handle authentication errors as authInterceptor will handle the redirect
                if (error.status !== 401 && error.status !== 403) {
                    Logger.log('Failed to load users report', error);
                }
            });
        };


        // loading pending review practices
        Report.getPendingPractices(function(success){
            $scope.pendingPractices = success;
        }, function(error) {
            // Silently handle authentication errors as authInterceptor will handle the redirect
            if (error.status !== 401 && error.status !== 403) {
                Logger.log('Failed to load pending practices report', error);
            }
        });
        
        // loading invitations, practices and users
        $scope.toggleInvitations('day');
        $scope.togglePractices('day');
        $scope.toggleUsers('day');

        // loading full list of reminders and triggering slicing to the current page
        // also loading site stats
        Report.get(function(success){
            $scope.referrals = success.referrals;
            $scope.counts = success; // counts matrix (invitations, practices, users) x (day, week, ytd)

            $scope.totalItems = success.event_logs.length;
            success.event_logs.forEach(function(item){
                item.event_name = item.type_event.split('_').map(function(item){
                    return item.charAt(0).toUpperCase() + item.slice(1);
                }).join(' ');

                rawEventLogs.push(item);
            });
            
            $scope.onPageUpdate();

            // site stats
            $scope.total_referrals = success.total_referrals;
            $scope.total_active_accounts = success.total_active_accounts;
            $scope.total_active_practices = success.total_active_practices;
        }, function(error) {
            // Silently handle authentication errors as authInterceptor will handle the redirect
            if (error.status !== 401 && error.status !== 403) {
                Logger.log('Failed to load general report data', error);
            }
        });

        // initial load for rejected email addresses
        loadRejections();

        // Email Blacklist management
        $scope.blacklistEntries = [];
        $scope.blacklistPerPage = 20;
        $scope.blacklistPager = { currentPage: 1 };
        $scope.blacklistTotal = 0;
        $scope.blacklistSort = { sort: 'created_at', direction: 'desc' };
        $scope.newBlacklistEntry = { pattern: '', description: '' };

        function loadBlacklist() {
            var offset = ($scope.blacklistPager.currentPage - 1) * $scope.blacklistPerPage;
            EmailBlacklist.get({
                limit: $scope.blacklistPerPage,
                offset: offset,
                sort: $scope.blacklistSort.sort,
                direction: $scope.blacklistSort.direction
            }, function(success) {
                $scope.blacklistEntries = success.entries || [];
                $scope.blacklistTotal = success.total_count || 0;
            }, function(error) {
                if (error.status !== 401 && error.status !== 403) {
                    Logger.log('Failed to load email blacklist', error);
                }
            });
        }

        $scope.onBlacklistPageUpdate = function() {
            loadBlacklist();
        };

        $scope.sortBlacklistBy = function(column) {
            if ($scope.blacklistSort.sort === column) {
                $scope.blacklistSort.direction = ($scope.blacklistSort.direction === 'asc') ? 'desc' : 'asc';
            } else {
                $scope.blacklistSort.sort = column;
                $scope.blacklistSort.direction = 'asc';
            }
            $scope.blacklistPager.currentPage = 1;
            loadBlacklist();
        };

        $scope.addBlacklistEntry = function() {
            if (!$scope.newBlacklistEntry.pattern || $scope.newBlacklistEntry.pattern.trim() === '') {
                Notification.error('Pattern is required');
                return;
            }

            EmailBlacklist.create({ blacklist_email: $scope.newBlacklistEntry }, function(success) {
                $scope.newBlacklistEntry = { pattern: '', description: '' };
                Notification.success('Blacklist entry added successfully');
                loadBlacklist();
            }, function(error) {
                var errorMsg = (error.data && error.data.errors) ? error.data.errors.join(', ') : 'Failed to add blacklist entry';
                Notification.error(errorMsg);
            });
        };

        $scope.deleteBlacklistEntry = function(entry) {
            if (!confirm('Are you sure you want to delete this blacklist entry?')) {
                return;
            }

            EmailBlacklist.remove({ id: entry.id }, function() {
                Notification.success('Blacklist entry deleted successfully');
                loadBlacklist();
            }, function(error) {
                Notification.error('Failed to delete blacklist entry');
            });
        };

        // initial load for email blacklist
        loadBlacklist();

        // ==========================================
        // Branding Requests Report Tab
        // ==========================================

        $scope.brandingRequests = {
            loading: false,
            entries: [],
            perPage: 20,
            pager: { currentPage: 1 },
            total: 0,
            sort: { sort: 'created_at', direction: 'desc' }
        };

        function loadBrandingRequests() {
            $scope.brandingRequests.loading = true;
            var offset = ($scope.brandingRequests.pager.currentPage - 1) * $scope.brandingRequests.perPage;
            Report.getBrandingRequests({
                limit: $scope.brandingRequests.perPage,
                offset: offset,
                sort: $scope.brandingRequests.sort.sort,
                direction: $scope.brandingRequests.sort.direction
            }, function(success) {
                $scope.brandingRequests.loading = false;
                $scope.brandingRequests.entries = success.branding_requests || [];
                $scope.brandingRequests.total = success.total_count || 0;
            }, function(error) {
                $scope.brandingRequests.loading = false;
                if (error.status !== 401 && error.status !== 403) {
                    Logger.log('Failed to load branding requests report', error);
                }
            });
        }

        $scope.onBrandingRequestsPageUpdate = function() {
            loadBrandingRequests();
        };

        $scope.sortBrandingRequestsBy = function(column) {
            if ($scope.brandingRequests.sort.sort === column) {
                $scope.brandingRequests.sort.direction = ($scope.brandingRequests.sort.direction === 'asc') ? 'desc' : 'asc';
            } else {
                $scope.brandingRequests.sort.sort = column;
                $scope.brandingRequests.sort.direction = 'asc';
            }
            $scope.brandingRequests.pager.currentPage = 1;
            loadBrandingRequests();
        };

        $scope.logoUrl = function(req) {
            return API_ENDPOINT + '/report/branding_requests/' + req.id + '/logo';
        };

        $scope.advanceBrandingRequest = function(req, status) {
            if (status === 'cancelled' && !confirm('Cancel this branding request?')) {
                return;
            }
            Report.updateBrandingRequest({ id: req.id }, { status: status }, function() {
                Notification.success('Branding request ' + status + '.');
                loadBrandingRequests();
            }, function(error) {
                if (error.status !== 401 && error.status !== 403) {
                    Notification.error('Unable to update branding request.');
                }
            });
        };

        loadBrandingRequests();

        // ==========================================
        // Geocoding Report Tab
        // ==========================================

        $scope.geocoding = {
            loading: false,
            statistics: {
                total_addresses: 0,
                geocoded_count: 0,
                failed_count: 0,
                success_rate: 0
            },
            failedAddresses: [],
            perPage: 20,
            pager: { currentPage: 1 },
            total: 0,
            sort: { sort: 'created_at', direction: 'desc' }
        };

        function loadGeocodingReport() {
            $scope.geocoding.loading = true;
            var offset = ($scope.geocoding.pager.currentPage - 1) * $scope.geocoding.perPage;
            Report.getGeocoding({
                limit: $scope.geocoding.perPage,
                offset: offset,
                sort: $scope.geocoding.sort.sort,
                direction: $scope.geocoding.sort.direction
            }, function(success) {
                $scope.geocoding.loading = false;
                $scope.geocoding.statistics = success.statistics || {};
                $scope.geocoding.failedAddresses = success.failed_addresses || [];
                $scope.geocoding.total = success.total_count || 0;
            }, function(error) {
                $scope.geocoding.loading = false;
                if (error.status !== 401 && error.status !== 403) {
                    Logger.log('Failed to load geocoding report', error);
                }
            });
        }

        $scope.onGeocodingPageUpdate = function() {
            loadGeocodingReport();
        };

        $scope.sortGeocodingBy = function(column) {
            if ($scope.geocoding.sort.sort === column) {
                $scope.geocoding.sort.direction = ($scope.geocoding.sort.direction === 'asc') ? 'desc' : 'asc';
            } else {
                $scope.geocoding.sort.sort = column;
                $scope.geocoding.sort.direction = 'asc';
            }
            $scope.geocoding.pager.currentPage = 1;
            loadGeocodingReport();
        };

        // Initial load for geocoding report
        loadGeocodingReport();

        // ==========================================
        // Heavy Receivers Report Tab (DCL-540)
        // ==========================================

        $scope.heavyReceivers = {
            loading: false,
            minPerMonth: 10,
            months: [],
            practices: []
        };

        function loadHeavyReceivers() {
            $scope.heavyReceivers.loading = true;
            Report.getHeavyReceivers({}, function(success) {
                $scope.heavyReceivers.loading = false;
                $scope.heavyReceivers.minPerMonth = success.min_per_month || 10;
                $scope.heavyReceivers.months = success.months || [];
                $scope.heavyReceivers.practices = success.practices || [];
            }, function(error) {
                $scope.heavyReceivers.loading = false;
                if (error.status !== 401 && error.status !== 403) {
                    Logger.log('Failed to load heavy receivers report', error);
                }
            });
        }

        // Initial load for the heavy receivers report
        loadHeavyReceivers();

        // ==========================================
        // Metrics History Tab
        // ==========================================
        
        $scope.metricsHistory = {
            loading: false,
            error: null,
            availableTypes: [],
            dateRange: { earliest: null, latest: null },
            descriptions: {},
            selectedMetrics: ['active_users', 'active_practices'],
            startDate: null,
            endDate: null,
            data: {},
            chartData: null,
            drilldown: {
                loading: false,
                visible: false,
                snapshot: null,
                records: [],
                type: null
            }
        };

        // Initialize date range to last year
        var today = new Date();
        var oneYearAgo = new Date();
        oneYearAgo.setFullYear(today.getFullYear() - 1);
        $scope.metricsHistory.startDate = oneYearAgo;
        $scope.metricsHistory.endDate = today;

        function formatDateForApi(date) {
            if (!date) return null;
            var d = new Date(date);
            return d.getFullYear() + '-' + 
                   String(d.getMonth() + 1).padStart(2, '0') + '-' + 
                   String(d.getDate()).padStart(2, '0');
        }

        // Parse a date string (YYYY-MM-DD) as a local date, not UTC.
        // new Date("2026-01-28") creates midnight UTC, which displays as
        // the previous day in western timezones. This function creates
        // midnight local time instead.
        function parseLocalDate(dateStr) {
            if (!dateStr) return null;
            var parts = dateStr.split('-');
            // new Date(year, monthIndex, day) creates a local date
            return new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
        }

        function loadMetricsMetadata() {
            Report.getMetrics({}, function(success) {
                $scope.metricsHistory.availableTypes = success.available_types || [];
                $scope.metricsHistory.dateRange = success.date_range || {};
                $scope.metricsHistory.descriptions = success.metric_descriptions || {};
                
                // If we have a date range from the data, use it
                if (success.date_range && success.date_range.earliest) {
                    $scope.metricsHistory.startDate = parseLocalDate(success.date_range.earliest);
                }
                if (success.date_range && success.date_range.latest) {
                    $scope.metricsHistory.endDate = parseLocalDate(success.date_range.latest);
                }
                
                // Auto-load chart after metadata is ready
                $scope.loadMetricsHistory();
            }, function(error) {
                if (error.status !== 401 && error.status !== 403) {
                    Logger.log('Failed to load metrics metadata', error);
                }
            });
        }

        $scope.loadMetricsHistory = function() {
            if ($scope.metricsHistory.selectedMetrics.length === 0) {
                Notification.warning('Please select at least one metric');
                return;
            }

            $scope.metricsHistory.loading = true;
            $scope.metricsHistory.error = null;

            var params = {
                metric_types: $scope.metricsHistory.selectedMetrics.join(','),
                start_date: formatDateForApi($scope.metricsHistory.startDate),
                end_date: formatDateForApi($scope.metricsHistory.endDate)
            };

            Report.getMetricsCompare(params, function(success) {
                $scope.metricsHistory.loading = false;
                $scope.metricsHistory.data = success.data || {};
                updateChart();
            }, function(error) {
                $scope.metricsHistory.loading = false;
                if (error.status !== 401 && error.status !== 403) {
                    $scope.metricsHistory.error = 'Failed to load metrics history';
                    Logger.log('Failed to load metrics history', error);
                }
            });
        };

        function updateChart() {
            var data = $scope.metricsHistory.data;
            var datasets = [];
            var labels = [];
            var labelSet = {};

            // Color palette for different metrics
            var colors = [
                { border: 'rgb(220, 53, 69)', background: 'rgba(220, 53, 69, 0.1)' },   // red - active users
                { border: 'rgb(255, 193, 7)', background: 'rgba(255, 193, 7, 0.1)' },   // yellow - active practices
                { border: 'rgb(0, 123, 255)', background: 'rgba(0, 123, 255, 0.1)' },   // blue - referrals
                { border: 'rgb(40, 167, 69)', background: 'rgba(40, 167, 69, 0.1)' },   // green
                { border: 'rgb(111, 66, 193)', background: 'rgba(111, 66, 193, 0.1)' }, // purple
                { border: 'rgb(23, 162, 184)', background: 'rgba(23, 162, 184, 0.1)' }  // cyan
            ];

            var colorIndex = 0;
            angular.forEach(data, function(snapshots, metricType) {
                var values = [];
                var snapshotsByDate = {};
                
                angular.forEach(snapshots, function(snapshot) {
                    var dateStr = snapshot.snapshot_date;
                    labelSet[dateStr] = true;
                    snapshotsByDate[dateStr] = snapshot;
                });

                var color = colors[colorIndex % colors.length];
                colorIndex++;

                datasets.push({
                    label: formatMetricLabel(metricType),
                    metricType: metricType,
                    data: snapshotsByDate,
                    borderColor: color.border,
                    backgroundColor: color.background,
                    fill: false,
                    tension: 0.1,
                    pointRadius: 3,
                    pointHoverRadius: 6
                });
            });

            // Sort labels chronologically
            labels = Object.keys(labelSet).sort();

            // Build final datasets with {x, y} data points for time scale
            var finalDatasets = datasets.map(function(ds) {
                var dataPoints = labels
                    .filter(function(label) {
                        return ds.data[label] != null;
                    })
                    .map(function(label) {
                        return {
                            x: label,  // Date string in YYYY-MM-DD format
                            y: ds.data[label].value
                        };
                    });
                return {
                    label: ds.label,
                    metricType: ds.metricType,
                    data: dataPoints,
                    borderColor: ds.borderColor,
                    backgroundColor: ds.backgroundColor,
                    fill: ds.fill,
                    tension: ds.tension,
                    pointRadius: 3,
                    pointHoverRadius: 6,
                    spanGaps: true
                };
            });

            $scope.metricsHistory.chartData = {
                datasets: finalDatasets
            };

            renderChart();
        }

        function formatMetricLabel(metricType) {
            var labels = {
                'active_users': 'Active Users',
                'active_practices': 'Active Practices',
                'total_referrals': 'Total Referrals',
                'total_users': 'Total Users',
                'total_practices': 'Total Practices',
                'new_users_mtd': 'New Users (MTD)',
                'new_practices_mtd': 'New Practices (MTD)',
                'new_referrals_mtd': 'New Referrals (MTD)'
            };
            return labels[metricType] || metricType;
        }

        var chartInstance = null;

        function renderChart() {
            var canvas = document.getElementById('metricsHistoryChart');
            if (!canvas) return;

            var ctx = canvas.getContext('2d');
            
            if (chartInstance) {
                chartInstance.destroy();
            }

            if (!$scope.metricsHistory.chartData) return;

            // Check if Chart.js is available
            if (typeof Chart === 'undefined') {
                Logger.log('Chart.js not available');
                return;
            }

            chartInstance = new Chart(ctx, {
                type: 'line',
                data: $scope.metricsHistory.chartData,
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    interaction: {
                        mode: 'index',
                        intersect: false
                    },
                    plugins: {
                        legend: {
                            position: 'top'
                        },
                        tooltip: {
                            callbacks: {
                                title: function(context) {
                                    return context[0].label;
                                }
                            }
                        }
                    },
                    scales: {
                        x: {
                            type: 'time',
                            time: {
                                unit: 'month',
                                displayFormats: {
                                    day: 'MMM D, YYYY',
                                    week: 'MMM D, YYYY',
                                    month: 'MMM YYYY',
                                    year: 'YYYY'
                                },
                                tooltipFormat: 'MMM D, YYYY'
                            },
                            title: {
                                display: true,
                                text: 'Date'
                            }
                        },
                        y: {
                            title: {
                                display: true,
                                text: 'Value'
                            },
                            beginAtZero: true
                        }
                    },
                    onClick: function(event, elements, chart) {
                        if (elements.length === 0) return;
                        
                        // Find the nearest element to the click position
                        var nearestElement = chart.getElementsAtEventForMode(
                            event, 
                            'nearest', 
                            { intersect: true }, 
                            false
                        )[0];
                        
                        if (!nearestElement) {
                            // If no direct intersection, use the clicked element
                            nearestElement = elements[0];
                        }
                        
                        var datasetIndex = nearestElement.datasetIndex;
                        var index = nearestElement.index;
                        var dataset = $scope.metricsHistory.chartData.datasets[datasetIndex];
                        var dataPoint = dataset.data[index];
                        var date = dataPoint.x;
                        var metricType = dataset.metricType;
                        
                        if (metricType === 'active_users' || metricType === 'active_practices') {
                            $scope.$apply(function() {
                                loadDrilldown(metricType, date);
                            });
                        }
                    }
                }
            });
        }

        function loadDrilldown(metricType, snapshotDate) {
            $scope.metricsHistory.drilldown.loading = true;
            $scope.metricsHistory.drilldown.visible = true;
            $scope.metricsHistory.drilldown.records = [];

            Report.getMetricsDrilldown({
                metric_type: metricType,
                snapshot_date: snapshotDate
            }, function(success) {
                $scope.metricsHistory.drilldown.loading = false;
                $scope.metricsHistory.drilldown.snapshot = success.snapshot;
                $scope.metricsHistory.drilldown.type = success.drilldown.type;
                $scope.metricsHistory.drilldown.records = success.drilldown.records || [];
            }, function(error) {
                $scope.metricsHistory.drilldown.loading = false;
                if (error.status !== 401 && error.status !== 403) {
                    Logger.log('Failed to load drilldown', error);
                    Notification.error('Failed to load drilldown details');
                }
            });
        }

        $scope.closeDrilldown = function() {
            $scope.metricsHistory.drilldown.visible = false;
            $scope.metricsHistory.drilldown.snapshot = null;
            $scope.metricsHistory.drilldown.records = [];
        };

        $scope.toggleMetricSelection = function(metricType) {
            var idx = $scope.metricsHistory.selectedMetrics.indexOf(metricType);
            if (idx > -1) {
                $scope.metricsHistory.selectedMetrics.splice(idx, 1);
            } else {
                $scope.metricsHistory.selectedMetrics.push(metricType);
            }
        };

        $scope.isMetricSelected = function(metricType) {
            return $scope.metricsHistory.selectedMetrics.indexOf(metricType) > -1;
        };

        function performCsvExport() {
            var data = $scope.metricsHistory.data;
            var metricTypes = Object.keys(data);

            // Collect all unique dates across all metrics
            var dateSet = {};
            angular.forEach(data, function(snapshots) {
                angular.forEach(snapshots, function(snapshot) {
                    dateSet[snapshot.snapshot_date] = true;
                });
            });
            var dates = Object.keys(dateSet).sort();

            // Build CSV header: Date, Metric1, Metric2, ...
            var header = ['Date'].concat(metricTypes.map(formatMetricLabel));
            
            // Build data rows
            var rows = dates.map(function(date) {
                var row = [date];
                metricTypes.forEach(function(metricType) {
                    var snapshot = data[metricType].find(function(s) {
                        return s.snapshot_date === date;
                    });
                    row.push(snapshot ? snapshot.value : '');
                });
                return row;
            });

            // Generate CSV content
            var csvContent = [header].concat(rows).map(function(row) {
                return row.map(function(cell) {
                    // Escape quotes and wrap in quotes if contains comma
                    var str = String(cell);
                    if (str.indexOf(',') >= 0 || str.indexOf('"') >= 0) {
                        return '"' + str.replace(/"/g, '""') + '"';
                    }
                    return str;
                }).join(',');
            }).join('\n');

            // Create and trigger download
            var blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            var link = document.createElement('a');
            var startDate = formatDateForApi($scope.metricsHistory.startDate);
            var endDate = formatDateForApi($scope.metricsHistory.endDate);
            link.href = URL.createObjectURL(blob);
            link.download = 'metrics_' + startDate + '_to_' + endDate + '.csv';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }

        function loadDataAndExport() {
            if ($scope.metricsHistory.selectedMetrics.length === 0) {
                Notification.warning('Please select at least one metric');
                return;
            }

            $scope.metricsHistory.loading = true;
            $scope.metricsHistory.error = null;

            var params = {
                metric_types: $scope.metricsHistory.selectedMetrics.join(','),
                start_date: formatDateForApi($scope.metricsHistory.startDate),
                end_date: formatDateForApi($scope.metricsHistory.endDate)
            };

            Report.getMetricsCompare(params, function(success) {
                $scope.metricsHistory.loading = false;
                $scope.metricsHistory.data = success.data || {};
                updateChart();
                
                if (Object.keys($scope.metricsHistory.data).length > 0) {
                    performCsvExport();
                } else {
                    Notification.warning('No data available for the selected date range.');
                }
            }, function(error) {
                $scope.metricsHistory.loading = false;
                if (error.status !== 401 && error.status !== 403) {
                    $scope.metricsHistory.error = 'Failed to load metrics history';
                    Logger.log('Failed to load metrics history', error);
                }
            });
        }

        $scope.exportMetricsCsv = function() {
            loadDataAndExport();
        };

        $scope.exportDrilldownCsv = function() {
            if (!$scope.metricsHistory.drilldown.snapshot) return;

            var snapshot = $scope.metricsHistory.drilldown.snapshot;
            var url = API_ENDPOINT + '/report/metrics_drilldown.csv?metric_type=' + snapshot.metric_type +
                      '&snapshot_date=' + snapshot.snapshot_date;
            
            $window.open(url, '_blank');
        };

        $scope.captureMetricsNow = function() {
            Report.captureMetrics({}, function(success) {
                Notification.success('Metrics captured for ' + success.snapshot_date);
                $scope.loadMetricsHistory();
            }, function(error) {
                if (error.status !== 401 && error.status !== 403) {
                    Notification.error('Failed to capture metrics');
                }
            });
        };

        // Load metrics metadata and initial data
        loadMetricsMetadata();

    }]);
